import React from 'react';
import './FAQ.css';

const FAQ: React.FC = () => {
  return (
    <div style={{ maxWidth: '900px', margin: '0 auto', padding: '2rem' }}>
      <h1>Ofte stilte spørsmål (FAQ)</h1>
      
      <p style={{ marginTop: '1rem', marginBottom: '2rem', fontSize: '1.1rem', color: '#4B5563' }}>
        Her finner du svar på de vanligste spørsmålene om Sykkelfest.
      </p>

      {/* Image */}
      <div style={{ textAlign: 'center', margin: '2rem 0' }}>
        <img 
          src="/faq-sykkelfest.png" 
          alt="Sykkelfest FAQ" 
          className="faq-hero-image"
        />
      </div>

      {/* Hva er Sykkelfest? */}
      <section style={{ marginTop: '2rem' }}>
        <h2>Hva er Sykkelfest?</h2>
        <p>
          Sykkelfest er en sosial matopplevelse på sykkel der du spiser ulike retter hos forskjellige 
          verter mens du sykler rundt i området sammen med din partner. Du møter nye mennesker ved hvert 
          stopp og opplever stedet fra en ny side!
        </p>
        <p style={{ marginTop: '1rem' }}>
          Typisk spiser du forrett hos et par, hovedrett hos et annet par, og dessert hos et tredje par - alle steder er dere 3 nye par som møtes. 
          Til slutt møtes alle til en felles etterfest.
        </p>
      </section>

      {/* Hvorfor skal jeg bli med? */}
      <section style={{ marginTop: '2rem' }}>
        <h2>Hvorfor skal jeg bli med?</h2>
        <p>
          Sykkelfest er mer enn bare mat og sykling – det er en unik mulighet til å bryte hverdagsrutinen og 
          oppleve noe nytt. Du får treffe mennesker du aldri ville møtt ellers, oppdage nye deler av ditt 
          eget nabolag, og dele gode stunder rundt matbordet med nye bekjentskap.
        </p>
        <p style={{ marginTop: '1rem' }}>
          Hver kveld gir deg nye perspektiver på mat, miljøet du bor i, og ikke minst – inspirasjon til 
          dine egne middager hjemme. Kanskje du lærer et nytt triks i kjøkkenet, prøver en rett du aldri 
          har laget før, eller bare får en kjærkomment påminnelse om hvor gøy det er å samle folk rundt bordet.
        </p>
        <p style={{ marginTop: '1rem' }}>
          <strong>Matlei, eller sosial lei? Meld deg på en sykkelfest og hent inspirasjon.</strong>
        </p>
      </section>
      
      {/* Hvordan delta? */}
      <section style={{ marginTop: '2rem' }}>
        <h2>Hvordan deltar jeg?</h2>
        <p>
          <strong>1. Finn en partner:</strong> Sykkelfest gjennomføres i par. Team opp med en venn, 
          kollega, eller noen du har lyst til å bli bedre kjent med!
        </p>
        <p style={{ marginTop: '1rem' }}>
          <strong>2. Meld dere på:</strong> Fyll ut påmeldingsskjemaet sammen. Du trenger en invitasjonskode 
          fra arrangøren.
        </p>
        <p style={{ marginTop: '1rem' }}>
          <strong>3. Alle er vert for en rett:</strong> Systemet tildeler hvilken rett dere vil lage hjemme hos dere 
          (forrett, hovedrett eller dessert).
        </p>
        <p style={{ marginTop: '1rem' }}>
          <strong>4. Få tildelt rute:</strong> Noen dager før arrangementet får dere beskjed om hvilken rett dere skal lage. Like før hvert stopp på ruten får dere adressen til de hjem 
          dere skal besøke.
        </p>
      </section>

      {/* Pris */}
      <section style={{ marginTop: '2rem' }}>
        <h2>Hva koster det?</h2>
        <p>
          <strong>Deltakelse er gratis!</strong> Det koster ingenting å melde seg på og delta i selve Sykkelfesten. 
          Arrangøren dekker kostnadene for å tilby deg denne opplevelsen. Les mer om{' '}
          <a href="/priser" style={{ color: 'var(--primary-color)', textDecoration: 'underline' }}>
            hvordan prising fungerer for arrangører
          </a>.
        </p>
        <p style={{ marginTop: '1rem' }}>
          <strong>Etterfest:</strong> Den felles etterfesten kan komme med en kostnad, avhengig av hva arrangøren 
          har organisert. Dette vil bli kommunisert på forhånd av arrangøren.
        </p>
        <p style={{ marginTop: '1rem' }}>
          <strong>Mat du lager:</strong> Som vert må du handle mat til retten du skal lage. Se budsjettguide nedenfor.
        </p>
        <div style={{ marginTop: '1.5rem', padding: '20px', backgroundColor: '#F9FAFB', borderRadius: '8px', border: '1px solid #E5E7EB' }}>
          <p style={{ margin: '0 0 12px 0', fontSize: '0.95rem', color: '#4B5563' }}>
            Liker du Sykkelfest og ønsker å støtte videreutvikling av plattformen? 
            Sykkelfest er utviklet som en hobby og lidenskap for å skape gode sosiale opplevelser. 
            All støtte går til hosting, vedlikehold og nye funksjoner som kommer alle sykkelfestere til gode.
          </p>
          <div style={{ textAlign: 'center' }}>
            <a 
              href="https://buymeacoffee.com/simonskothn" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <img 
                src="/bmc-button.png" 
                alt="Buy Me a Coffee" 
                style={{ maxWidth: '160px', width: '100%', height: 'auto' }}
              />
            </a>
          </div>
        </div>
      </section>

      {/* Budsjett */}
      <section style={{ marginTop: '2rem' }}>
        <h2>Hvor mye bør jeg budsjettere for mat?</h2>
        <p>
          <strong>Det er ingen regel, men anbefalt budsjett per rett: 300-400 kr</strong> (totalt for 6 personer)
        </p>
        <div style={{ marginTop: '1rem', padding: '16px', backgroundColor: '#EFF6FF', borderLeft: '4px solid #2563EB', borderRadius: '8px' }}>
          <h3 style={{ margin: '0 0 12px 0', fontSize: '1.1rem', color: '#1E40AF' }}>Viktig om drikke:</h3>
          <ul style={{ margin: '0', paddingLeft: '20px', color: '#1E3A8A' }}>
            <li style={{ marginBottom: '8px' }}>
              <strong>Forrett og dessert:</strong> Som vert må du inkludere drikke (vann, brus, vin, etc.)
            </li>
            <li>
              <strong>Hovedrett:</strong> Drikke er IKKE inkludert - gjestene tar med egen drikke
            </li>
          </ul>
        </div>
        <p style={{ marginTop: '1rem', fontSize: '0.95rem', color: '#6B7280' }}>
          Tips: Du lager mat til totalt 6 personer (dere selv + 2 par som kommer på besøk).
        </p>
      </section>

      {/* Matpreferanser */}
      <section style={{ marginTop: '2rem' }}>
        <h2>Hva med allergier og matpreferanser?</h2>
        <p>
          Når dere melder dere på, oppgir dere eventuelle allergier og kostpreferanser. Systemet 
          vil prøve at dere blir matchet med verter som kan tilby mat dere kan spise, men det er ingen garanti.
        </p>
        <p style={{ marginTop: '1rem' }}>
          Som vert oppgir dere hvilke typer kosthold dere kan lage mat til (vegetar, vegansk, 
          glutenfritt, etc.). Dette for å prøve å matche dere med eventuelle matpreferanser og gi alle en god opplevelse! Igjen, ingen garanti.
        </p>
      </section>

      {/* Sykkel */}
      <section style={{ marginTop: '2rem' }}>
        <h2>Må jeg ha egen sykkel?</h2>
        <p>
          Ja, om arrangøren legger opp til sykling må du ha tilgang til en fungerende sykkel. Sørg for at sykkelen er i god stand med 
          fungerende lys og bremser. Hvis du ikke har egen sykkel, kan du vurdere å leie en bysykkel eller el-sykkel for kvelden. Noen arrangement kan også være så nære at man kan gå.
        </p>
        <p style={{ marginTop: '1rem' }}>
          <strong>Viktig:</strong> Husk lys på sykkelen! Mange arrangementer går utover kvelden når 
          det er mørkt ute.
        </p>
      </section>

      {/* Avstand */}
      <section style={{ marginTop: '2rem' }}>
        <h2>Hvor langt må jeg sykle?</h2>
        <p>
          Sykkelavstandene holdes moderate. Systemet forsøker å optimalisere rutene slik at du ikke trenger å 
          sykle veldig langt mellom hvert stopp. Typisk vil du sykle totalt 5-15 km i løpet av kvelden, 
          avhengig av hvor i området de ulike vertene bor.
        </p>
      </section>

      {/* Tidslinje */}
      <section style={{ marginTop: '2rem' }}>
        <h2>Hvordan er tidsplanen?</h2>
        <p>
          Tidsplanen kan tilrettelegges av arrangør. En typisk Sykkelfest-kveld kan se slik ut:
        </p>
        <ul style={{ marginTop: '1rem', lineHeight: '1.8' }}>
          <li><strong>18:00-19:00:</strong> Forrett hos første vert</li>
          <li><strong>19:00-20:30:</strong> Hovedrett hos andre vert</li>
          <li><strong>20:30-21:30:</strong> Dessert hos tredje vert</li>
          <li><strong>21:30+:</strong> Felles etterfest på fast lokasjon</li>
        </ul>
        <p style={{ marginTop: '1rem', fontSize: '0.95rem', color: '#6B7280' }}>
          Tidene kan variere litt avhengig av arrangementet. Du får detaljert tidsplan når rutene sendes ut.
        </p>
      </section>

      {/* Meldinger fra systemet */}
      <section style={{ marginTop: '2rem' }}>
        <h2>Hvordan mottar jeg informasjon fra systemet?</h2>
        <p>
          All kommunikasjon fra Sykkelfest skjer via <strong>e-post</strong>. Sørg for at du oppgir 
          en e-postadresse du sjekker regelmessig, og har tilgang til fra mobiltelefon når du er på sykkelfesten!
        </p>
        <div style={{ marginTop: '1rem', padding: '16px', backgroundColor: '#EFF6FF', borderLeft: '4px solid #3B82F6', borderRadius: '8px' }}>
          <p style={{ margin: '0 0 8px 0', fontWeight: 'bold', color: '#1E40AF' }}>
            ✉️ VIKTIG: Verifiser e-postadressen din!
          </p>
          <p style={{ margin: '0', fontSize: '0.95rem', color: '#1E3A8A' }}>
            Etter du har opprettet en bruker, verifiser e-postadressen din via din{' '}
            <strong>profilside</strong> som du finner i menyen. Dette sikrer at den registrerte 
            e-postadressen fungerer og at du mottar all viktig informasjon om arrangementene dine.
          </p>
        </div>
        <div style={{ marginTop: '1rem', padding: '16px', backgroundColor: '#F0FDF4', borderLeft: '4px solid #10B981', borderRadius: '8px' }}>
          <h3 style={{ margin: '0 0 12px 0', fontSize: '1.1rem', color: '#065F46' }}>📧 E-postvarsler du vil motta:</h3>
          <ul style={{ margin: '0', paddingLeft: '20px', color: '#064E3B' }}>
            <li style={{ marginBottom: '8px' }}>
              <strong>Bekreftelse på påmelding:</strong> Umiddelbart etter registrering
            </li>
            <li style={{ marginBottom: '8px' }}>
              <strong>Hvilken rett du skal lage:</strong> Kommer i god tid (flere dager før arrangementet)
            </li>
            <li style={{ marginBottom: '8px' }}>
              <strong>Hvor du skal være for hver rett:</strong> Kommer <em>underveis i arrangementet</em>
            </li>
            <li>
              <strong>Påminnelser og viktig info:</strong> Fra arrangøren ved behov
            </li>
          </ul>
        </div>
        <div style={{ marginTop: '1rem', padding: '12px', backgroundColor: '#F5F3FF', border: '1px solid #A78BFA', borderRadius: '8px' }}>
          <p style={{ margin: '0 0 8px 0', fontSize: '0.95rem', color: '#5B21B6' }}>
            <strong>📋 Oversikt over e-poster:</strong> Alle e-poster som er sendt til deg fra dine 
            påmeldte Sykkelfest-arrangementer er tilgjengelig i <strong>Logg</strong>-fanen på 
            arrangementets informasjonsside. Der kan du se alle meldinger du har mottatt. Følg også med der under sykkelfesten.
          </p>
        </div>
        <div style={{ marginTop: '1rem', padding: '12px', backgroundColor: '#FFFBEB', border: '1px solid #FCD34D', borderRadius: '8px' }}>
          <p style={{ margin: '0', fontSize: '0.95rem', color: '#78350F' }}>
            <strong>💡 Hvorfor kommer stedene underveis?</strong><br/>
            For å bevare spenningen! Du får beskjed om hvor du skal være til neste rett mens du er 
            på forrige stopp. Dette gjør opplevelsen mer spennende og spontan - du vet ikke på forhånd 
            hvem du skal møte hvor! 🎉
          </p>
        </div>
      </section>

      {/* Alkohol */}
      <section style={{ marginTop: '2rem' }}>
        <h2>Hva med alkohol?</h2>
        <div style={{ padding: '16px', backgroundColor: '#FEE2E2', borderLeft: '4px solid #DC2626', borderRadius: '8px' }}>
          <p style={{ margin: '0 0 8px 0', fontWeight: 'bold', color: '#991B1B' }}>
            ⚠️ VIKTIG ADVARSEL
          </p>
          <p style={{ margin: '0', color: '#7F1D1D' }}>
            Det er <strong>forbudt å sykle i beruset tilstand</strong> etter norsk lov (vegtrafikkloven §§ 22-23). 
            Promillegrensen for sykling er 0,2. Du er selv ansvarlig for din trafikksikkerhet og for å 
            overholde norsk lov. Arrangør og Sykkelfest er ikke ansvarlige for eventuelle brudd på loven.
          </p>
        </div>
        <p style={{ marginTop: '1rem' }}>
          Planlegg trygg transport hjem på forhånd hvis du planlegger å drikke alkohol. Alternativer kan 
          være drosje, kollektivtransport, eller å bli hentet av en edru person.
        </p>
      </section>

      {/* Avmelding */}
      <section style={{ marginTop: '2rem' }}>
        <h2>Kan jeg melde meg av?</h2>
        <p>
          Ja, du kan melde deg av fram til påmeldingsfristen (vanligvis 5 dager før arrangementet). 
          Etter dette er det vanskelig å endre rutene, så vær sikker på at du kan delta før fristen går ut! System er avhengig av at alle møter opp for at det skal fungere.
        </p>
        <p style={{ marginTop: '1rem' }}>
          Ved akutt forfall etter fristen, kontakt arrangøren direkte så snart som mulig.
        </p>
      </section>

      {/* Kontakt */}
      <section style={{ marginTop: '2rem' }}>
        <h2>Hvem kontakter jeg ved spørsmål?</h2>
        <p>
          For spørsmål om et spesifikt arrangement, kontakt arrangøren direkte. Kontaktinformasjon 
          finner du på arrangementssiden.
        </p>
        <p style={{ marginTop: '1rem' }}>
          For generelle spørsmål om Sykkelfest-systemet, besøk vår{' '}
          <a href="/kontakt" style={{ color: 'var(--primary-color)', textDecoration: 'underline' }}>
            kontaktside
          </a>.
        </p>
      </section>

      {/* Flere spørsmål */}
      <section style={{ marginTop: '3rem', padding: '20px', backgroundColor: '#EFF6FF', borderRadius: '12px', textAlign: 'center' }}>
        <h3 style={{ marginTop: 0 }}>Har du flere spørsmål?</h3>
        <p>
          Ta kontakt med oss via{' '}
          <a href="/kontakt" style={{ color: 'var(--primary-color)', fontWeight: 'bold', textDecoration: 'underline' }}>
            kontaktskjemaet
          </a>{' '}
          så hjelper vi deg!
        </p>
      </section>
    </div>
  );
};

export default FAQ;
